import { createStyles } from 'antd-style'
import './style.css'
export const useStyle = createStyles(({ token }) => ({
  thinkContent: {
    borderLeft: '1px solid rgba(17, 17, 51, .1);',
    paddingLeft: '20px',
    whiteSpace: 'pre-wrap',
  },
  thinkContainer: {
    marginBottom: '20px',
    fontSize: 14,
    color: '#61666b',
  },
  thinkHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  botMessage: {
    display: 'flex',
    flexDirection: 'column',
    padding: token.padding,
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadius,
    width: 'calc(100% - 32px)',
    alignSelf: 'flex-start',
    marginRight: 'auto',
    transition: 'all 0.2s ease-out',
    willChange: 'transform, height',
    transform: 'translateZ(0)',
    backfaceVisibility: 'hidden',
    pre: {
      span: {
        fontFamily:
          'ui-monospace, SFMono-Regular, SF Mono, Menlo, Consolas, Liberation Mono, monospace',
      },
    },
  },

  messageText: {
    // whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    transition: 'all 1s ease-out',
    willChange: 'contents, height',
    transform: 'translateZ(0)',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',

    pre: {
      background: token.colorBgContainer,
      borderRadius: token.borderRadius,
      margin: `${token.marginXS}px 0`,
      overflow: 'auto',

      '&::-webkit-scrollbar': {
        width: '6px',
        height: '6px',
      },

      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },

      '&::-webkit-scrollbar-thumb': {
        background: token.colorTextTertiary,
        borderRadius: '3px',
      },

      '&::-webkit-scrollbar-thumb:hover': {
        background: token.colorTextSecondary,
      },
    },
  },
  languageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#F1F2F5',
    borderTopLeftRadius: '0.5rem',
    borderTopRightRadius: '0.5rem',
    padding: '0.25rem 0.75rem',
    fontSize: '0.85rem',
  },
  languageLabel: {
    fontSize: '14px',
    color: '#494C57',
  },
  thinkBlock: {
    borderLeft: `4px solid ${token.colorPrimary}`,
    paddingLeft: token.padding,
    margin: `${token.marginXS}px 0`,
    color: token.colorTextSecondary,
    transition: 'all 1s ease-out',
    willChange: 'contents, height',
    transform: 'translateZ(0)',
  },
  codeBlock: {
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: token.colorTextTertiary,
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: token.colorTextSecondary,
    },
    backgroundColor: '#efeef2',
    borderRadius: '6px',
    overflowX: 'auto', // 横向滚动溢出
    maxWidth: '100%',
    whiteSpace: 'pre-wrap', // 自动换行
    wordBreak: 'break-word',
  },
  codeInline: {
    backgroundColor: '#ececec',
    padding: '0.2em 0.4em',
    fontSize: '85%',
    fontWeight: 500,
    borderRadius: '0.25rem',
    wordBreak: 'break-word',
  },

  toolTag: {
    backgroundColor: token.colorBgContainer,
    borderRadius: '4px',
    borderLeft: '4px solid #1677ff',
    padding: '12px 16px',
    fontSize: token.fontSizeSM,
    color: token.colorText,
    lineHeight: 1.6,
    position: 'relative',
    margin: '8px 0',
    display: 'block',
    '&::before': {
      content: '"⚙️"',
      marginRight: '8px',
      fontSize: '14px',
    },
  },
}))
